import { render } from "./headlineSmall.vue?vue&type=template&id=26e36032"
import script from "./headlineSmall.vue?vue&type=script&lang=js"
export * from "./headlineSmall.vue?vue&type=script&lang=js"

import "./headlineSmall.vue?vue&type=style&index=0&id=26e36032&lang=scss"

import exportComponent from "C:\\Users\\chbo\\Documents\\repos\\semco-maritime-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__